import type {TruncatedCellHoverMode} from '../types/Api';

/** Applied when a preset's settings predate the truncatedCellHoverMode field. */
export const DEFAULT_TRUNCATED_CELL_HOVER_MODE: TruncatedCellHoverMode = 'EXPAND';
